<app-bottom-sheet-mobile-header (closeEvent)="close()" />
<div class="mx-6 mb-3 flex flex-col">
  <button
    class="text-left font-normal text-base text-ui-dark h-10"
    (click)="close('csv')"
  >
    Export to CSV
  </button>
  <button
    class="text-left font-normal text-base text-ui-dark h-10"
    (click)="close('json')"
  >
    Export to JSON
  </button>
</div>
